const currentState = {
  meetingLocked: {
    data: null,
    error: null,
  },
  meetingFolderLocked: {
    data: null,
    error: null,
  },
  isCompanySecretary: {
    data: null,
    error: null,
  },
};

const reducer = (state = currentState, action) => {
  switch (action.type) {
    case "INSTANTIATE_MEETING_LOCKED":
      const meetingLocked = { ...state.meetingLocked };

      meetingLocked.data = action.payload.data ?? false;

      meetingLocked.error = action.payload.error ?? false;

      return {
        ...state,
        meetingLocked: meetingLocked,
      };
    case "INSTANTIATE_MEETING_FOLDER_LOCKED":
      const meetingFolderLocked = { ...state.meetingFolderLocked };

      meetingFolderLocked.error = action.payload.meetingFolderLocked ?? false;

      meetingFolderLocked.error = action.payload.error ?? false;

      return {
        ...state,
        meetingFolderLocked: meetingFolderLocked,
      };
    default:
      return state;
  }
};

export default reducer;
